/**
 * iOS browser hints for Setup (mobile profile + CardDAV).
 * Apple’s configuration flows are most reliable in Mobile Safari.
 */

function isIOSDevice() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  if (/iPad|iPhone|iPod/.test(ua)) return true
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}

/**
 * Mobile Safari (not Chrome/Firefox/Edge/other in-app browsers on iOS).
 */
export function isLikelyMobileSafari() {
  if (!isIOSDevice()) return false
  const ua = navigator.userAgent
  if (/CriOS|FxiOS|EdgiOS/.test(ua)) return false
  if (/GSA\//.test(ua)) return false
  if (/(FBAN|FBAV|Instagram|Line\/|\bFBIOS\b)/i.test(ua)) return false
  return /Safari\//.test(ua) && /Version\//.test(ua)
}

/** iPhone / iPad / iPod (and iPad-class Mac) — supports installing a mobile configuration profile from Safari. */
export function isIOS() {
  return isIOSDevice()
}

/** iOS but user is in Chrome, in-app browser, etc. — prefer Safari for Setup. */
export function isIOSPreferSafariBrowser() {
  return isIOSDevice() && !isLikelyMobileSafari()
}

/**
 * Opens the same URL in the system Safari app (iOS 17+ typically).
 * @param {string} absoluteHref full URL including query (e.g. handoff with doggos_l)
 */
export function toXSafariHttpsUrl(absoluteHref) {
  const u = new URL(absoluteHref, typeof window !== 'undefined' ? window.location.origin : undefined)
  return `x-safari-https://${u.host}${u.pathname}${u.search}${u.hash}`
}

const HANDOFF_REDIRECT_KEY = 'doggos_ios_safari_handoff_redirect'

export function shouldTrySafariHandoffRedirect() {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return false
  return !sessionStorage.getItem(HANDOFF_REDIRECT_KEY)
}

export function markSafariHandoffRedirectAttempted() {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(HANDOFF_REDIRECT_KEY, '1')
  } catch {
    /* private mode */
  }
}
